module.exports = __webpack_public_path__ + "static/media/dashboard-add-icon.1a1d9d00.svg";